/**
 * Restores a page the backend bounced here as /?to=/apps/... (see the
 * backend's lib/http/admin-deep-link.ts). Imported first in main.tsx so the
 * router starts on the right URL. Only same-origin /apps paths are accepted.
 */
const to = window.location.pathname === "/" ? new URLSearchParams(window.location.search).get("to") : null
if (to && /^\/apps(\/[A-Za-z0-9._~\-/]*)?(\?[^#]*)?$/.test(to) && !to.startsWith("//")) {
  window.history.replaceState(window.history.state, "", to)
}
export {}
